import React, { Component } from 'react';
import Slider from "react-slick";
import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (<div className={className}
        style={{ ...style, display: "block", }}
        onClick={onClick}>
        <div><i className="fas fa-angle-right"></i></div>
    </div>);
}
  
function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (<div className={className}
        style={{ ...style, display: "block", }}
        onClick={onClick}>
        <div><i className="fas fa-angle-left"></i></div>
    </div>);
}

class FindOnlineTutors extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: props.authentication.loggedIn,
            loading: false
        };
    }

    componentDidMount() {
        
    }

    render() {
        const { cateArray } = this.props;
        const { loggedIn } = this.state;
        const settings = {
            dots: false,
            speed: 500,
            slidesToShow: 6,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            responsive: [
                {
                  breakpoint: 1024,
                  settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    dots: true
                  }
                },
                {
                  breakpoint: 768,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                  }
                },
                {
                  breakpoint: 480,
                  settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                  }
                },
                {
                    breakpoint: 400,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
              ]
            
        };

        
        return (<section className="tutors my-5">
            <div className="container">
                <div className="row">
                    <div className="col-lg-8 col-md-9 text-center mx-auto"> 
                        <h2>Find Online Tutors in Any Subject</h2>
                        {/* <p>00+ subjects from plenty areas of knowledge. Learn any topic, 
                        subject and language with qualified<br/> tutors from all over the world.
                        </p> */}
                    </div>
                    <div className="col-md-12"> 

                        <Slider {...settings}>
                            {cateArray && cateArray.map(item => 
                                <a className="subject text-center" key={`cat-${item.id}`} href={"search-tutors?subject="+item.name}>
                                    <div className="image">
                                        <img src='/images/svg/XMLID_1_.svg' alt="Banner" />
                                    </div>
                                    <div className="text">
                                        <h4 className="title">{item.name}</h4>
                                    </div>
                                </a>
                            )}
                        </Slider>

                    </div>
                    {!loggedIn &&
                    <div className="col-md-12 text-center my-5"> 
                        <Link to="/search-tutors" className="btn btn-primary">FIND A TUTOR</Link>
                    </div>}
                </div>
            </div>
        </section> );
    }
}

const authenticationSelector = createSelector(
    state => state.authentication,
    authentication => authentication
);

const mapStateToProps = createSelector(
    authenticationSelector,
    (authentication) => ({
        authentication
    })
);

export default connect(mapStateToProps)(FindOnlineTutors);